/** 与hk-admin-pc/test预约姓名转换一致：复姓优先，姓与名分别转换。 */
import pinyin from 'js-pinyin';

export const SINGLE_SURNAMES = new Set(
  '赵钱孙李周吴郑王冯陈褚卫蒋沈韩杨朱秦尤许何吕施张孔曹严华金魏陶姜' +
  '戚谢邹喻柏水窦章云苏潘葛奚范彭郎鲁韦昌马苗凤花方俞任袁柳酆鲍史唐' +
  '费廉岑薛雷贺倪汤滕殷罗毕郝邬安常乐于时傅皮卞齐康伍余元卜顾孟平黄和' +
  '穆萧尹姚邵湛汪祁毛禹狄米贝明臧计伏成戴谈宋茅庞熊纪舒屈项祝董梁杜阮' +
  '蓝闵席季麻强贾路娄危江童颜郭梅盛林刁钟徐邱骆高夏蔡田樊胡凌霍虞万支' +
  '柯昝管卢莫经房裘缪干解应宗丁宣贲邓郁单杭洪包诸左石崔吉钮龚程嵇邢滑' +
  '裴陆荣翁荀羊於惠甄曲家封芮羿储靳汲邴糜松井段富巫乌焦巴弓牧隗山谷车' +
  '侯宓蓬全郗班仰秋仲伊宫宁仇栾暴甘斜厉戎祖武符刘景詹束龙叶幸司韶郜黎' +
  '蓟薄印宿白怀蒲邰从鄂索咸籍赖卓蔺屠蒙池乔阴郁胥能苍双闻莘党翟谭贡劳' +
  '逄姬申扶堵冉宰郦雍却璩桑桂濮牛寿通边扈燕冀郏浦尚农温别庄晏柴瞿阎充' +
  '慕连茹习宦艾鱼容向古易慎戈廖庾终暨居衡步都耿满弘匡国文寇广禄阙东欧' +
  '殳沃利蔚越夔隆师巩厍聂晁勾敖融冷訾辛阚那简饶空曾毋沙乜养鞠须丰巢关' +
  '蒯相查后荆红游竺权逯盖益桓公'
);
export const COMPOUND_SURNAMES = [
  '司马', '欧阳', '诸葛', '端木', '上官', '尉迟', '公孙', '东方', '皇甫', '南宫',
  '夏侯', '独孤', '宇文', '慕容', '司徒', '司空', '鲜于', '闾丘', '申屠', '呼延',
  '拓跋', '沮渠', '公羊', '公西', '公冶', '澹台', '太叔', '令狐', '钟离', '左丘',
  '东门', '西门', '南门', '北门', '东郭', '南郭', '西郭', '东野', '夹谷', '谷梁',
  '段干', '百里', '东宫', '仲孙', '叔孙', '季孙', '长孙', '王孙', '轩辕', '子车', '乐正'
];

/** 接收繁转简后的姓名，输出姓、名大写拼音；未识别姓氏时不强行拆首字。 */
export function getSurnamePinyin(name) {
  const boundary = name.length >= 2 && COMPOUND_SURNAMES.includes(name.slice(0, 2)) ? 2
    : SINGLE_SURNAMES.has(name.charAt(0)) ? 1 : 0;
  return [boundary ? pinyin.getFullChars(name.slice(0, boundary)).toUpperCase() : '',
    name.slice(boundary) ? pinyin.getFullChars(name.slice(boundary)).toUpperCase() : ''];
}
